"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const template_parser_1 = require("@osmosys/template-parser");
const index_1 = require("./index");
const use_debounce_1 = require("use-debounce");
const react_use_1 = require("react-use");
// import { useOsmosysContext } from '../../../hooks';
exports.useRenderedHtml = () => {
    const { state: { draftEmail }, prefs: { view }, } = index_1.useEmailCanvasContext();
    const { dispatchCanvasAction } = index_1.useEmailCanvasUpdate();
    // const {
    //   featureFlags: { writeRenderedHtmlToDraftEmailHtml },
    // } = useOsmosysContext();
    const isIdle = react_use_1.useIdle(11 * 1000);
    const [render] = use_debounce_1.useDebouncedCallback(() => {
        console.log('Requesting email preview render...');
        if (view !== 'new' &&
            draftEmail &&
            draftEmail.html &&
            draftEmail.blocks) {
            const newHtml = new template_parser_1.BlueprintTemplateRenderer({}).renderHtmlDocumentString(draftEmail.html, draftEmail.blocks);
            // if (writeRenderedHtmlToDraftEmailHtml) {
            //   dispatchCanvasAction({
            //     data: {
            //       draftEmail: {
            //         ...draftEmail,
            //         // html: newHtml,
            //         renderedHTML: newHtml,
            //       },
            //     },
            //     type: 'state',
            //   });
            // } else {
            dispatchCanvasAction({
                data: {
                    draftEmail: Object.assign(Object.assign({}, draftEmail), { html: newHtml }),
                },
                type: 'state',
            });
            // }
        }
    }, 700, {
        maxWait: 2000,
    });
    react_use_1.useInterval(() => {
        if (!isIdle) {
            render();
        }
    }, 10 * 1000);
    react_use_1.useMount(render);
    react_1.useEffect(render, [
        draftEmail && draftEmail.html,
        draftEmail && draftEmail.blocks,
        draftEmail && dispatchCanvasAction,
        view,
        render,
    ]);
};
//# sourceMappingURL=useRenderedHtml.js.map